import ServiceCard from "../components/ServiceCard";
import { services } from "../data/services";

export default function Services() {
  return (
    <div className="pt-16 md:pt-20">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#033644] to-[#1E3A8A] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Nuestros Servicios
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Soluciones tecnológicas completas adaptadas a las necesidades
            específicas de tu empresa
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
            {services.map((service) => (
              <div key={service.id} className="space-y-4">
                <ServiceCard service={service} />
                {service.details && (
                  <p className="text-gray-600 px-4 leading-relaxed">
                    {service.details}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
